import axios, {Axios} from 'axios'
import {Config} from '../Config'

export class AxiosQon {
    axiosInstance: Axios;

    constructor(config: Config) {
        const axiosConfig = {
            withCredentials: true,
            baseURL: config.getBaseUrl(),
            timeout: 3000,
        }
        const quarticCookie = config.getCookie()
        if(config.getCookie()){
            axiosConfig['headers'] = {
                Cookie: `quartic_cookie=${quarticCookie};`
            }
        }

        this.axiosInstance = axios.create(axiosConfig)
    }
}

